import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

export const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    );
  }

  // TODO: check if we also need redirect to login page here
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

export const customHeaderMiddleware = (headerFlag: boolean) => {
  return new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'Prenuvo-Radiologist': headerFlag,
      },
    }));

    return forward(operation);
  });
};

export const httpLink = (uri: string) =>
  new HttpLink({
    uri,

    // Possible options: 'same-origin' or 'include' or 'omit'
    // Unfortunately 'same-origin' doesn't work
    credentials: 'include',
  });

export const apolloClient = (link: ApolloLink) =>
  new ApolloClient({
    link,

    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            practitioners: {
              keyArgs: false,
              read(practitioners: any) {
                return practitioners;
              },
            },

            locations: {
              keyArgs: false,
              read(locations: any) {
                return locations;
              },
            },
          },
        },
      },
    }),
  });

export const getApolloClient = (apiEndpoint: string, headerFlag = false) => {
  const apolloLink = ApolloLink.from([
    errorLink,
    customHeaderMiddleware(headerFlag),
    httpLink(apiEndpoint),
  ]);
  return apolloClient(apolloLink);
};
